import type { PageTitleBreadcrumb } from './PageTitle';

export function Breadcrumb({ label, icon, onClick }: PageTitleBreadcrumb) {
    const content = (
        <>
            {icon && (
                <span className="size-6 shrink-0 flex items-center justify-center text-grey-200 [&>svg]:size-6">
                    {icon}
                </span>
            )}
            <span className="text-2xl font-medium leading-9 tracking-[-0.01em] text-grey-200 truncate">
                {label}
            </span>
        </>
    );

    if (onClick) {
        return (
            <button
                type="button"
                onClick={onClick}
                className="flex flex-row items-center gap-1.5 min-h-9 min-w-0 cursor-pointer hover:text-white-100"
            >
                {content}
            </button>
        );
    }

    return (
        <div className="flex flex-row items-center gap-1.5 min-h-9 min-w-0">
            {content}
        </div>
    );
}
